import React from 'react'
import Header from './Components/Header'

export default function Terms() {
  return (
    <div>
      <Header/>
      <h1>these are our terms</h1>
    </div>
  )
}
